import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { AccountSettings } from "@gettactic/api";

export const useAccountSettings = (organizationId: string | null | undefined) => {
  const { apiClient } = useTacticHooks();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["account-settings", organizationId],
    queryFn: async () => {
      if (!organizationId) {
        return null;
      }
      try {
        const data = await apiClient.orgOrOfficeSettings.getAccountSettings();
        if (data.ok && data.result) {
          return data.result;
        }
        throw data;
      } catch (error) {
        console.error("Error fetching account settings", error);
        throw error;
      }
    },
    enabled: !!organizationId,
  });

  const mutation = useMutation({
    mutationFn: async (settings: Partial<AccountSettings>) => {
      const data = await apiClient.orgOrOfficeSettings.updateAccountSettings(settings);
      if (data.ok && data.result) {
        return data.result;
      }
      throw data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["account-settings", organizationId] });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });

  return { query, mutation };
};
